import { npcLabel, patientLabel } from './labels';
import { activeNpcs } from './npc';

const sourceCharacterKeys = ['patient', '_startLocation', '_endLocation'];
export const npcKeys = ['_startLocation', '_endLocation'];

// Nodes with a target character that were saved before the field existed have no
// targetCharacterKey and default to User. An explicit null means a new node still
// awaiting a selection, so callers treat that as an error rather than defaulting.
export const DEFAULT_TARGET_CHARACTER_KEY = 'user';

export function targetCharacterKeyOrDefault(targetCharacterKey) {
  return targetCharacterKey === undefined ? DEFAULT_TARGET_CHARACTER_KEY : targetCharacterKey;
}

export function getAllCharacters(caseConf) {
  if (!caseConf) return [];
  const npcs = (activeNpcs(caseConf) || []).map(npc => ({
    ...npc,
    label: npcLabel(npc)
  }));
  const patientDialogue = caseConf.dialogue;
  const characters = [
    {
      key: 'patient',
      name: patientLabel(caseConf),
      label: patientLabel(caseConf),
      dialogue: patientDialogue
    },
    ...npcs,
    {
      key: 'user',
      name: 'User',
      label: 'User',
    },
    {
      key: 'anyone',
      name: 'Anyone',
      label: 'Anyone',
    }
  ];
  return characters || [];
}

export function getSourceCharacters(caseConf) {
  const characters = getAllCharacters(caseConf);
  return characters.filter(char => sourceCharacterKeys.includes(char.key));
}

export function getNpcCharacters(caseConf) {
  const characters = getAllCharacters(caseConf);
  return characters.filter(char => npcKeys.includes(char.key));
}

export function getTargetCharacters(caseConf) {
 return getAllCharacters(caseConf);
}

export function getCharacter(caseConf, characterKey) {
  const characters = getAllCharacters(caseConf);
  return characters.find(char => char.key === characterKey);
}
